(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'enumControl',
            [
                'CHROME',
                EnumControlFactory
            ]
        );

    // Factory Method
    function EnumControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.ENUM + CHROME.POSTFIX
        };

    }
})();



